export default require.context('./svgs', false, /\.svg$/);
